import { Star } from "lucide-react";

export function Stars({ value = 3, size = 13 }) {
  return (
    <span className="inline-flex items-center gap-0.5" data-testid="confidence-stars" aria-label={`Confidence ${value} of 5`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= value ? "fill-[#F59E0B] text-[#F59E0B]" : "fill-transparent text-slate-600"}
        />
      ))}
    </span>
  );
}

export default Stars;
